import { useIntegrationStore } from 'store/useIntegrationStore';

import ConnectorSetup from '../ConnectorSetup';
import Settings from '../Settings';

const Configuration = () => {
  const integrationListData: any = useIntegrationStore(state => state.integrationList);
  const RUNByADPData = integrationListData.filter((tab: any) => tab.key === 'adp-run')[0] ?? {};

  return !RUNByADPData?.is_connected ? <ConnectorSetup /> : <Settings />;
};

export default Configuration;
